import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import WorkItemsSchema from 'schemas/workitems.schema.json';
import { useAppContext } from 'hooks/useAppContext';
import { addWorkItem, updateWorkItem } from 'utils/WorkItemsUtils';
import {useFormContext} from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';

const AddWorkItem = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {

    const _disabledProperties = disabledProperties;
    const _hiddenProperties = hiddenProperties;

    const { selectedProject, selectedProjectData } = useAppContext();

    const formContext = useFormContext();

    useEffect(() => {
        !formContext.schema && formContext.updateSchema(WorkItemsSchema);
    })

    if (CRUDType === "INSERT") {
        !_disabledProperties.includes('IsActive') && _disabledProperties.push('IsActive') && _hiddenProperties.push('IsActive');
    } else {
        _disabledProperties.includes('IsActive') && _disabledProperties.splice(_disabledProperties.indexOf('IsActive'), 1);
        _hiddenProperties.includes('IsActive') && _hiddenProperties.splice(_hiddenProperties.indexOf('IsActive'), 1);
    }
    // contact specific CRUD functions
    const onSubmit = async (values) => {
        let result;
        if (CRUDType === "INSERT") {
            const edits = values;
            delete edits.WorkItemId;
            result = await addWorkItem(selectedProject, values);
            if(result.success) {
                setTimeout(callback, 1000);
            }
        } else if (CRUDType === "UPDATE") {
            result = await updateWorkItem(selectedProject, values,defaultValues);
            if(result.success) {
                setTimeout(callback, 1000);
            }
            
        };

        return result;
    };
    /* 
    on rare occasions, this component may be reached before the full AppContext is done initializing.
    so this form only renders when there is data in selectedProjectData 
    */
    return selectedProjectData && formContext.ready ? 
    withExtension(DynamicForm, { schema: WorkItemsSchema, orientation, onSubmit, defaultValues, disabledProperties: _disabledProperties, hiddenProperties: _hiddenProperties, definitions: formContext.definitions }) :
    <SkeletonForm />

}



AddWorkItem.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

AddWorkItem.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}




export default AddWorkItem
